import { configureStore, createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'modal',
  initialState: { open: false, record: null },
  reducers: {
    toggleModal: (state, action) => {
      const { open, record } = action.payload;
      state.open = open;
      state.record = record;
    },
  },
});

export const { toggleModal } = slice.actions;
export const store = configureStore({
  reducer: slice.reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
